import { jsx as _jsx } from "react/jsx-runtime";
import { HugeiconsIcon } from '@hugeicons/react';
import { ICONS } from '../icons';
const SIZE = {
    sm: 'size-4',
    md: 'size-5',
    lg: 'size-6',
    xl: 'size-8',
};
const TONE = {
    default: '',
    muted: 'text-muted-foreground',
    accent: 'text-primary',
    danger: 'text-destructive',
    warning: 'text-warning',
    inverse: 'text-background',
};
export function Icon({ name, size = 'md', tone = 'default', label, className }) {
    const classes = [SIZE[size], TONE[tone], 'shrink-0'].filter(Boolean);
    if (className !== undefined)
        classes.push(className);
    /*
     * НАСТОЯЩИЙ `svg`, А НЕ ФОН НА `span`. Прежняя редакция рисовала иконку
     * фоновым изображением через плагин Iconify: иконка не наследовала цвет
     * текста нигде, кроме `currentColor`-масок, и её нельзя было найти
     * сценарию как `svg`. Hugeicons отдаёт разметку; `strokeWidth` - из
     * поставки пресета.
     */
    return (_jsx(HugeiconsIcon, { icon: ICONS[name], strokeWidth: 2, "data-icon": name, className: classes.join(' '), role: label === undefined ? undefined : 'img', "aria-label": label, "aria-hidden": label === undefined ? true : undefined }));
}
//# sourceMappingURL=Icon.js.map